import { Checkbox } from '@/components/ui/checkbox';
import { ThemeSearchBehaviorType, useBuilderStore } from '@/stores/builder';

export const DEFAULT_THEME_SEARCH_BEHAVIOR: ThemeSearchBehaviorType = {
  enableSearchSuggestion: true,
  showProductVendor: true,
  showProductPrice: true,
};

export default function ThemeSearchBehaviorSetting() {
  const builder = useBuilderStore((state) => ({
    theme: state.theme,
    setTheme: state.setTheme,
  }));

  const searchBehavior = builder.theme?.searchBehavior || DEFAULT_THEME_SEARCH_BEHAVIOR;

  const setValue = (value: Partial<ThemeSearchBehaviorType>) => {
    builder.setTheme({
      searchBehavior: { ...searchBehavior, ...value },
    });
  };

  return (
    <div>
      <div className='mb-4 font-bold'>Search suggestions</div>
      <div className='flex gap-x-1'>
        <Checkbox
          id='enableSearchSuggestion'
          aria-label='Select'
          className='mx-2 mt-1'
          checked={searchBehavior.enableSearchSuggestion}
          onCheckedChange={(checked) => {
            setValue({ enableSearchSuggestion: !!checked });
          }}
        />
        <label htmlFor='enableSearchSuggestion'>Enable search suggestions</label>
      </div>
      {/* <div className='flex mt-4 gap-x-1'>
        <Checkbox
          id='showProductVendor'
          aria-label='Select'
          className='mx-2 mt-1'
          checked={searchBehavior.showProductVendor}
          onCheckedChange={(checked) => {
            setValue({ showProductVendor: !!checked });
          }}
        />
        <div className='flex flex-col'>
          <label htmlFor='showProductVendor'>Show product vendor</label>
          <label htmlFor='showProductVendor' className='mt-1 text-xs'>
            Visible when search suggestions enabled.
          </label>
        </div>
      </div> */}
      {/* <div className='flex mt-4 gap-x-1'>
        <Checkbox
          id='showProductPrice'
          aria-label='Select'
          className='mx-2 mt-1'
          checked={searchBehavior.showProductPrice}
          onCheckedChange={(checked) => {
            setValue({ showProductPrice: !!checked });
          }}
        />
        <div className='flex flex-col'>
          <label htmlFor='showProductPrice'>Show product price</label>
          <label htmlFor='showProductPrice' className='mt-1 text-xs'>
            Visible when search suggestions enabled.
          </label>
        </div>
      </div> */}
    </div>
  );
}
